import $ from "jquery";
import EventMap from "../admin/map/EventMap.js";
import initializeCustomScript from "../common/initializeCustomScript";

// This method called in both onLoad and on pjax:success. This provides proper reinitialization of components during ajax
// and reloads. There are few concernes you need to take into account:
// 1. Avoid initialization of components that where already initialized
// 2. Unbind events before binding

const initialize_components = function () {
  grabPageConfig();
  initializeHomeEventsSearch();
  initializeGoogleTracker();
  GoogleTrackerECommerceSend();

  if ($("[data-admin]").attr === "true") {
    createAdminChannel();
  }

  if ($("[data-pooling-script-url]").length > 0) {
    initializePooling();
  }

  if (typeof initializeTimepicker === "function") {
    initializeTimepicker();
  }

  initializeTooltip();

  if ($(".tickebuyer-seating-section").length > 0) {
    initializeTicketBuyerSeatingSection();
  }

  if ($(".admin-seating-section").length > 0) {
    initializeAdminSeatingSection();
  }

  if (window.initializeOrderPromocodeForm) {
    window.initializeOrderPromocodeForm();
  }

  // Notifications initialization
  $("body").on(
    ".flash .icon-remove, .flash .t-icon-remove",
    "click",
    function () {
      $(this)
        .parent()
        .fadeOut("fast", function () {
          $(this).remove();
        });
    }
  );

  // Initialize google map for setting event location
  if (document.getElementById("event-map")) {
    EventMap.init(document.getElementById("event-map"), (lat, lng, zoom) =>
      $("form.new_entity, form.edit_entity")
        .find("#entity_city")
        .val("fix me")
        .end()
        .find("#entity_zip")
        .val("91111")
        .end()
        .find("#entity_latitude")
        .val(lat)
        .end()
        .find("#entity_longitude")
        .val(lng)
        .end()
        .find("#entity_zoom_level")
        .val(zoom)
    );
    $("form.new_entity, form.edit_entity")
      .find("entity[street_address]")
      .keypress((event) => event.keyCode !== 13);

    $("form.new_entity, form.edit_entity")
      .find("#entity_location_name, #entity_map_info")
      .change(function () {
        EventMap.setInfo(
          $(this).parents("form").find("#entity_location_name").val(),
          $(this).parents("form").find("#entity_map_info").val()
        );
      });
  }

  // Bootstrap dropdowns initialization
  // Login form uses Bootstrap dropdown to show login form
  $(".dropdown-toggle").dropdown();

  // User can personalize all tickets by filling in three steps
  if ($("#buyer-information").length > 0) {
    const orderSlider = $(".order-edit");
    const $form = $("#buyer-information");

    // check if we have errors
    // if yes, open correct window
    const $errorMessage = $form.find("span.error").eq(0);
    const currentStep =
      ($errorMessage.length > 0 &&
        $errorMessage.parents(".order-step").index(".order-step")) ||
      0;

    // wrap form into flsider
    orderSlider
      .fslider($form.parent(), $(".order-edit-navigation"), {
        slideSelector: ".order-step",
        slideContinueButtonSelector: ".fslider-continue-btn",
        current: currentStep,
      })
      .bind("onSelect", function (e, index, isLast) {
        if (isLast) {
          // Verify if accept legal terms checkbox is checked
          $(".jsOrderCheckLegalTerms").trigger("change");
        }

        const $ticketsTable = $form.find(".order-tickets");
        const $customQuestionsTable = $form.find(".order-custom-questions");
        return $ticketsTable.find("tbody tr").each(function (index) {
          const $ticketHolder = $customQuestionsTable
            .find(".order-question:eq(" + index + ")")
            .find(".ticket-holder");
          return $ticketHolder.html(
            $(this).find("[data-field='fname'] input").val() +
              " " +
              $(this).find("[data-field='lname'] input").val()
          );
        });
      });
  }
};

initializeCustomScript(initialize_components);
